import React from "react";
import PropTypes from "prop-types";
import {
  FilterBoxContainer,
  ChannelSearchInputContainer,
  FilterInput,
  SearchButton,
  CrossIcon,
} from "./SearchBox.styles";
import { useTranslation } from "react-i18next";
const SearchIconImage = `${process.env.PUBLIC_URL}/images/search-icon.png`;
const CrossIconImage = `${process.env.PUBLIC_URL}/images/cross-icon.svg`;

/**
 * FilterBox component
 * @component
 */
const SearchBox = ({ epgFilters, handleSearchChange, crossClickHandler }) => {
  const { t: translate } = useTranslation();
  return (
    <FilterBoxContainer>
      <ChannelSearchInputContainer>
        <FilterInput
          type="text"
          placeholder={translate("search_channel")}
          defaultValue={epgFilters.customFilter || ""}
          onChange={handleSearchChange}
        />
        <SearchButton src={SearchIconImage} alt="search" data-testid="searchIcon" />
        {epgFilters.customFilter && (
          <CrossIcon onClick={crossClickHandler} role="presentation" alt="crossIcon" src={CrossIconImage} />
        )}
      </ChannelSearchInputContainer>
    </FilterBoxContainer>
  );
};

SearchBox.propTypes = {
  epgFilters: PropTypes.shape({
    customFilter: PropTypes.string,
  }),
};

export default SearchBox;
